<template>
    <v-dialog
        v-model="dialogModel"
        persistent
        width="500"
    >
        <v-card>
            <v-card-title class="title">Force Password</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                
                <v-form ref="vForm">
                    <v-text-field :disabled="loading" :rules="[formRules.required]" prepend-icon="fa-key" type="password" label="New Password" v-model="models.new_password"></v-text-field>
                    <v-text-field :disabled="loading" :rules="[formRules.required, retypePassword]" type="password"  prepend-icon="fa-unlock-alt" label="Retype Password" v-model="models.retype_password"></v-text-field>
                </v-form>
                
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" @click="submit" flat>SUBMIT</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import VueCookies from 'vue-cookies';
    import axios from 'axios';

    export default {


        created : function(){
            this.eventHub.$on('openForcePassword', () => {
                if(this.userData.temp_pass == ""){
                    this.dialogModel = false;
                    this.openForcePassword = false;
                }else{
                    this.dialogModel = true;
                    this.openForcePassword = true;
                }
            });

            this.eventHub.$on('closeForcePassword', () => {
                this.dialogModel = false;
                this.openForcePassword = false;
            });
        },
        mounted : function(){
            this.token = VueCookies.get(this.cookieKey).token;

            console.log(this.userData);

            
        },
        data : function(){
            return {
                token : '',
                dialogModel : false,
                loading : false,
                models : {
                    new_password : '',
                    retype_password : ''
                }
            }
        },
        methods : {
            submit : function(){

                if(this.$refs.vForm.validate()){

                    let _this = this,
                        formData = new FormData();

                    formData.append('id', _this.userData.id);
                    formData.append('new_password', _this.models.new_password);

                    _this.loading = true;

                    axios.create({
                        baseURL : _this.apiUrl,
                        headers : {
                            'Authorization' : `Bearer ${_this.token}`
                        }
                    })
                    .post('/users/new/force/password', formData)
                    .then((res) => {

                        let cookie = VueCookies.get(_this.cookieKey);
                        cookie.data.user.temp_pass = "";

                        VueCookies.set(_this.cookieKey, cookie);

                        _this.userData.temp_pass = "";

                        _this.loading = false;
                        _this.dialogModel = false;

                    });

                }

            },

            retypePassword : function(){

                return (this.models.new_password === this.models.retype_password) ? true : 'Password did not match';

            }
        }
    };
</script>

